module.exports = __webpack_public_path__ + "static/media/game-lobby.17ed030c.png";